<template>
    <div class="sticker-list-wrap">
        <el-card class="sticker-list-body">
            <!-- 筛选区域 -->
            <el-form :inline="true" size="mini" class="demo-form-inline">
                <el-form-item label="筛选">
                    <el-select v-model="selects.sticker_log_id" filterable>
                        <el-option
                                v-for="(item,index) in this.stickerLogList"
                                :key="index"
                                :value="item.value"
                                :label="item.label"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="selects.platform_id" placeholder="所属平台" clearable>
                        <el-option
                            v-for="item in platformList"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="getSelects">筛选</el-button>
                    <el-button size="mini" @click="reset">重置</el-button>
                </el-form-item>
            </el-form>
            <el-row class="common-con-btns mb5">
                <el-col :span="24">
                    <el-alert>温馨提示：贴纸码状态统计，每天凌晨更新一次！</el-alert>
                </el-col>
            </el-row>
            <!-- 表格区域 -->
            <el-row :gutter="12">
                <el-col :span="24">
                    <el-timeline>
                        <el-timeline-item placement="top"
                                          v-for="(item, index) in this.dataList"
                                          :key="index" :timeline="item.id">
                            <el-card>
                                <h4>[{{item.id}}] {{item.batch_name}}</h4>
                                <p>批次数量：
                                    <el-tag size="small">{{item.num}}</el-tag>
                                </p>
                                <div>
                                    <el-badge :value="item1.num" class="item" v-for="(item1,index1) in item.list"
                                              :key="index1">
                                        <el-button size="small">{{item1.status_name}}</el-button>
                                    </el-badge>
                                </div>
                            </el-card>
                        </el-timeline-item>

                    </el-timeline>


                </el-col>
            </el-row>

        </el-card>


    </div>

</template>

<script>
    import {stickerApi} from "@/api/sticker";

    export default {
        data() {
            return {
                // 有权限的平台列表
                platformList: [],
                selects: {
                    sticker_log_id: 0,
                    platform_id: '',
                },
                dataList: [],
                stickerLogList: [{'value': 0, 'label': '[0] 所有批次'}],
            };
        },
        created() {
            this.initData();
        },
        methods: {
            /**
             * 初始化
             */
            initData() {
                this.getPlatformPermission()
                this.getBatchStickerLogs();
                this.selects.sticker_log_id = this.$route.params.id ? parseInt(this.$route.params.id) : this.selects.sticker_log_id;
                this.getList();
            },
            // 获取有权限的平台列表
            getPlatformPermission() {
                this.$EpetJs.Common.ajax('get', stickerApi.getPlatformPermissionUrl).then(res => {
                    if(res) {
                        this.platformList = res.data.data || []
                    }
                })
            },
            /**
             * 获取贴纸列表
             */
            getList() {
                this.$EpetJs.Common.get(stickerApi.getStickerStatusUrl + this.selects.sticker_log_id, {
                    platform_id: this.selects.platform_id
                }, {
                    needLoading: true
                }).then(res => {
                    if (res) {
                        this.dataList = res.data.data;
                    }
                });
            },

            /**
             * 筛选
             */
            getSelects() {
                this.getList();
            },
            /**
             * 重置
             */
            reset() {
                this.selects.sticker_log_id = 0;
                this.selects.platform_id = ''
                this.getList();
            },
            /**
             * 获取贴纸码批次
             */
            getBatchStickerLogs() {
                this.$EpetJs.Common.get(stickerApi.getStickerLogsBatchUrl).then(res => {
                    if (res) {
                        if (res.data.data) {
                            let tempArr = []
                            res.data.data.forEach(item => {
                                let obj = {}
                                obj.value = item.id && parseInt(item.id)
                                obj.label = `[${obj.value}] ${item.batch_name}`
                                tempArr.push(obj)
                            })
                            this.stickerLogList = tempArr
                            this.stickerLogList.unshift({'value': 0, 'label': '[0] 所有批次'})
                        }
                    }
                });
            }
        }
    };
</script>
<style lang="less">
    .sticker-select-input,
    .sticker-select {
        width: 110px;
    }

    .sticker-list-wrap {
        .sticker-list-body {
            min-height: calc(100vh - 60px);

            .delete-icon {
                color: #000;
                font-size: 20px;
                vertical-align: middle;
            }

            .detail-icon {
                color: #000;
                font-size: 20px;
                vertical-align: middle;
            }
        }
    }

    .item {
        margin-top: 10px;
        margin-right: 40px;
    }
</style>
